import { ComponentTypes, Initiallocations } from "../../../config/config";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { ILocationBuilder } from "../../../interfaces/ILocationBuilder";
import { BaseLocationBuilder } from "./BaseLocationBuilder";

export class OneDriveFolderLocationBuilder extends BaseLocationBuilder implements ILocationBuilder {
    constructor(private webUrl: string, private sharePointListId: string) {
        super();
    }

    getInitialLocation = (): IPageSettings => {
        const location = Initiallocations.find(item => item.type === ComponentTypes.OneDrive);

        return {
            type: location.type,
            id: location.id,
            directory: "",
            displayName: location.name,
            webUrl: location.type === ComponentTypes.OneDrive ? this.webUrl : "",
            sharePointListId: this.sharePointListId
        };
    };

    async build(fileWebUrl: string): Promise<string[]> {
        const path = this.getPath(fileWebUrl);
        const paths = path.split("/")
            .filter(value => value);

        return this.buildPathsToCall(paths);
    }

    private getPath(fileWebUrl: string) {
        return fileWebUrl.replace(this.webUrl, "");
    }
}
